"use client"
import { useEffect, useState } from "react"
import Icon from "@/components/ui/Icon"

interface Toast {
  id: string
  message: string
  type: "success" | "error" | "info" | "warning"
}

let toastListeners: ((toasts: Toast[]) => void)[] = []
let currentToasts: Toast[] = []

export function showToast(message: string, type: "success" | "error" | "info" | "warning" = "success") {
  const id = Math.random().toString(36).substring(2)
  currentToasts = [...currentToasts, { id, message, type }]
  toastListeners.forEach(fn => fn([...currentToasts]))
  setTimeout(() => {
    currentToasts = currentToasts.filter(t => t.id !== id)
    toastListeners.forEach(fn => fn([...currentToasts]))
  }, 3500)
}

export default function ToastContainer() {
  const [toasts, setToasts] = useState<Toast[]>([])

  useEffect(() => {
    toastListeners.push(setToasts)
    return () => { toastListeners = toastListeners.filter(fn => fn !== setToasts) }
  }, [])

  if (toasts.length === 0) return null

  return (
    <div style={{ position: "fixed", bottom: 24, right: 24, zIndex: 9999, display: "flex", flexDirection: "column", gap: 10 }}>
      {toasts.map(toast => (
        <div key={toast.id} style={{
          padding: "14px 20px",
          borderRadius: 12,
          fontSize: 14,
          fontWeight: 600,
          fontFamily: "Inter, sans-serif",
          boxShadow: "0 8px 32px rgba(0,0,0,0.15)",
          background: toast.type === "success" ? "#3d8b5f" : toast.type === "error" ? "#c44444" : toast.type === "warning" ? "#C8963E" : "#1B2D54",
          color: "white",
          display: "flex",
          alignItems: "center",
          gap: 10,
          animation: "slideIn 0.2s ease",
          maxWidth: 360,
        }}>
          <span>{toast.type === "success" ? "✓" : toast.type === "error" ? <Icon name="X" size={14} /> : toast.type === "warning" ? "!" : <Icon name="Info" size={14} />}</span>
          {toast.message}
        </div>
      ))}
      <style>{`@keyframes slideIn { from { transform: translateX(100%); opacity: 0; } to { transform: translateX(0); opacity: 1; } }`}</style>
    </div>
  )
}